import React, { ReactText } from 'react';
import { toast } from 'react-toastify';
import { MyAccountToast } from 'b2b-apps/shop/myAccount/common/components/MyAccountToast';

enum MY_ACCOUNT_MESSAGE {
  duplicationErrorAddToWishlist = 'duplicationErrorAddToWishlist',
  errorAddAddress = 'errorAddAddress',
  errorAddToWishlist = 'errorAddToWishlist',
  errorChangePassword = 'errorChangePassword',
  errorCreateAddress = 'errorCreateAddress',
  errorCreateAndAddToWishlist = 'errorCreateAndAddToWishlist',
  errorCreateUser = 'errorCreateUser',
  errorCreateWishlist = 'errorCreateWishlist',
  errorEditAddress = 'errorEditAddress',
  errorEditContactInformation = 'errorEditContactInformation',
  errorRemoveAddress = 'errorRemoveAddress',
  errorRemoveUser = 'errorRemoveUser',
  errorRemoveWishlist = 'errorRemoveWishlist',
  errorRemoveWishlistItem = 'errorRemoveWishlistItem',
  errorRemoveWishlistItems = 'errorRemoveWishlistItems',
  errorUpdateUser = 'errorUpdateUser',
  errorUpdateWishlist = 'errorUpdateWishlist',
  errorUpdateWishlistItem = 'errorUpdateWishlistItem',
  errorUpdateWishlistReference = 'errorUpdateWishlistReference',
  successAddAddress = 'successAddAddress',
  successAddToWishlist = 'successAddToWishlist',
  successChangePassword = 'successChangePassword',
  successCreateAddress = 'successCreateAddress',
  successCreateAndAddToWishlist = 'successCreateAndAddToWishlist',
  successCreateUser = 'successCreateUser',
  successCreateWishlist = 'successCreateWishlist',
  successEditAddress = 'successEditAddress',
  successEditContactInformation = 'successEditContactInformation',
  successRemoveAddress = 'successRemoveAddress',
  successRemoveItem = 'successRemoveItem',
  successRemoveItems = 'successRemoveItems',
  successRemoveUser = 'successRemoveUser',
  successRemoveWishlist = 'successRemoveWishlist',
  successUpdateUser = 'successUpdateUser',
  successUpdateWishlist = 'successUpdateWishlist',
}

const showMyAccountToast = (
  messageId: MY_ACCOUNT_MESSAGE,
): ReactText=> toast(<MyAccountToast messageId={messageId} />, {
  className: 'cds-Toast-Wrapper',
  progressClassName: 'cds-Toast-ProgressBar',
});

export { MY_ACCOUNT_MESSAGE, showMyAccountToast };
